import React from 'react';
import classnames from 'classnames';
import { string, shape, arrayOf } from 'prop-types';
import { I18n, translate } from '@fiverr-private/i18n-react';
import { makersExperience } from '@fiverr-private/logo_maker_analytics';
import { IDEAS_HUB_ACTIONS, IDEAS_HUB_SECTIONS } from '../../constants';

const { reportIdeasHubBtnClicked } = makersExperience.discoverLogoIdeas;

const GetInspired = ({ inspiredRowData, titlePrefix, className }) => (
    <div className={classnames('get-inspired-row', className)}>
        <h2 className="section-title">
            <I18n k={`logo_maker_perseus.discover_logo_ideas.get_inspired.${titlePrefix}`} />
        </h2>
        <div className="get-inspired-cards-wrapper">
            {inspiredRowData.map(({ title, link, imgUrl }) => (
                <div className="inspired-card-wrapper" key={title}>
                    <a
                        href={link}
                        onClick={() =>
                            reportIdeasHubBtnClicked({
                                actionType: IDEAS_HUB_ACTIONS.TAG_CLICKED,
                                section: IDEAS_HUB_SECTIONS.STYLES,
                                tag: title,
                            })
                        }
                        className="inspired-card-link"
                    >
                        <img
                            src={imgUrl}
                            alt={translate('logo_maker_perseus.discover_logo_ideas.get_inspired.card_alt', {
                                params: {
                                    industry: translate(
                                        `logo_maker_perseus.discover_logo_ideas.get_inspired.card_titles.${title}`
                                    ),
                                },
                            })}
                        />
                        <p>
                            <I18n k={`logo_maker_perseus.discover_logo_ideas.get_inspired.card_titles.${title}`} />
                        </p>
                    </a>
                </div>
            ))}
        </div>
    </div>
);

GetInspired.propTypes = {
    titlePrefix: string,
    inspiredRowData: arrayOf(
        shape({
            title: string,
            link: string,
            imgUrl: string,
        })
    ),
    className: string,
};

export default GetInspired;
